import { render, staticRenderFns } from "./object.vue?vue&type=template&id=6a31e5ec&"
import script from "./object.vue?vue&type=script&lang=js&"
export * from "./object.vue?vue&type=script&lang=js&"
import style0 from "./object.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports